import React from 'react'
import Main from '../cpn/Main'
import dayjs from 'dayjs'
import { Space} from 'antd';
function DeskHome(props) {
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'));
    return (
        <Main 
            selectedKeys={['/DeskHome']}
            reportRejectedNum={props.reportRejectedNum} 
            reportNeedApproveNum={props.reportNeedApproveNum} 
            reportNeedReadNum={props.reportNeedReadNum} 
            loanRejectedNum={props.loanRejectedNum} 
            loanNeedApproveNum={props.loanNeedApproveNum} 
            loanNeedReadNum={props.loanNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum} 
            expenseNeedApproveNum={props.expenseNeedApproveNum} 
            expenseNeedReadNum={props.expenseNeedReadNum} 
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            reportEndNeedReadNum={props.reportEndNeedReadNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
            yh_qx={props.yh_qx}
        >
            <Space style={{padding:"30px",fontSize:"16px",}}  orientation='vertical'>
                <div>亲爱的{qy_name}：</div>
                <div>&emsp;&emsp;今天是{dayjs().format('YYYY年MM月DD日星期dd')}，祝您工作顺利、心想事成！</div>               
            </Space>
        </Main>
    )
}

export default DeskHome